import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "week",
  measure: "",
  segments: [],
  minDate: null,
  maxDate: null,
  filters: [],
  postFilters: [],
};
